export default __webpack_public_path__ + "6cc8d5dc50eb2422ddf56543ea722893.jpg";